import React from 'react';

/**
 * Floating bottom-right launcher button. Visible only when a demo user is
 * signed in. Clicking opens the welcome card so the user can start (or
 * restart) the guided tour.
 */
export default function DemoTourLauncher({ onClick }) {
    return (
        <button
            type="button"
            className="demo-tour-launcher"
            onClick={onClick}
            aria-label="Open guided demo tour"
        >
            <span className="demo-tour-launcher__icon" aria-hidden="true">✨</span>
            Guided Demo
        </button>
    );
}
